'use client';

import { useAccount } from 'frontastic/hooks';
import { isDevelopment } from 'helpers/utils/environment';
import { useCallback } from 'react';

const StoreSelectorTastic = () => {
  const { stores, setStoreContext } = useAccount();

  const handleStoreSelect = useCallback(async (storeKey: string, subDomain: string) => {
    await setStoreContext(subDomain);
    
    // Get current hostname and construct new URL with subdomain
    const currentUrl = window.location.hostname;
    const baseUrl = isDevelopment() ? 'localhost:3000' : currentUrl
    const protocol = isDevelopment() ? 'http' : 'https';
    const newUrl = `${protocol}://${subDomain}.${baseUrl}${window.location.pathname}`;
    
    // Redirect to the new URL
    window.location.href = newUrl;
  }, [setStoreContext]);

  if (!stores || stores.length === 0) {
    return <div className="container mx-auto p-4">No distributors available</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <div className="mb-6">
      <span className="text-2xl font-bold mb-6">Select a distributor</span>

      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-3 px-6 text-left font-medium text-gray-600">Distributor Name</th>
              <th className="py-3 px-6 text-left font-medium text-gray-600">Address</th>
            </tr>
          </thead>
          <tbody>
            {stores.map((store) => (
              <tr 
                key={store.key} 
                className="border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors"
                onClick={() => handleStoreSelect(store.key, store.subDomain)}
              >
                <td className="py-4 px-6">{store.name}</td>
                <td className="py-4 px-6">{store.businessUnit?.address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StoreSelectorTastic;
